export interface SessionContextDefinition {
  version:number;
  interview:{title:string;description:string|null;instructions:string|null;focus_areas:string[];
    difficulty_level:string|null;language:string;ai_interviewer_name:string|null};
}
export class SessionContextDefinitionError extends Error {}
export function applySessionContextDefinition<T extends object>(interview:T,definition?:SessionContextDefinition|null):T {
  if(definition==null)return interview;
  const fields=definition.interview;
  if(definition.version!==1 || !fields || typeof fields.title!=='string' || typeof fields.language!=='string'
    || !Array.isArray(fields.focus_areas) || fields.focus_areas.some(value=>typeof value!=='string')
    || ['description','instructions','difficulty_level','ai_interviewer_name'].some(key=>{
      const value=fields[key as keyof typeof fields];return value!==null && typeof value!=='string';
    }))throw new SessionContextDefinitionError('Session context definition is invalid or unsupported.');
  return {...interview,title:fields.title,description:fields.description || '',instructions:fields.instructions || '',
    focus_areas:[...fields.focus_areas],difficulty_level:fields.difficulty_level || 'intermediate',
    language:fields.language,ai_interviewer_name:fields.ai_interviewer_name};
}
